import Link from 'next/link';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { SUBSCRIPTION_INVOICES } from '@/lib/routes/privateRoutes';

import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';
import { Trans } from '@/components/tools/translation';

type UpsellCrownIconProps = {
    className?: string;
    tooltip?: string;
    withLink?: boolean;
};

export const UpsellCrownIcon = ({ className, tooltip, withLink = true }: UpsellCrownIconProps) => {
    const { t } = useTranslation('commons');

    const tooltipContent = withLink ? (
        <Trans
            i18nKey="commons:upgrade_plan_tooltip.admin"
            components={{
                link: <Link className="text-icoBlue" href={SUBSCRIPTION_INVOICES} />
            }}
        />
    ) : (
        tooltip ?? t('upsell_modal.hint')
    );

    return (
        <Tooltip
            content={tooltipContent}
            interactive={true}
            appendTo={() => document.body}
            placement="right"
            className={className}>
            <Icon icon="crown" className="ml-1 text-icoBlue" />
        </Tooltip>
    );
};
